import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../../CSS/AnalyticsBasedOnPaymentmode.css";
import Select from "react-select";
import axios from "axios";
import moment from "moment";
import ReactApexChart from "react-apexcharts";
import LoadingScreen from "../../../Components/LoadingScreen";
import Loading2 from "../../../Components/Loading2";
import "../../../CSS/ListofVehicles.css";
import { useNavigate } from "react-router-dom";
import TransportDashboardsNavbar from "../../../Components/TransportDashboardsNavbar";


import DepotOutwardInterchange from "./Depot/DepotOutwardInterchange";
import DepotGateInwards from "./Depot/DepotGateInwards";

const Depot = () => {
  const [selectedComponent, setSelectedComponent] = useState({
    value: "DepotOutwardInterchange",
    label: "Depot Outward Interchange",
  });
  const options = [
    {
      value: "DepotOutwardInterchange",
      label: "Depot Outward Interchange",
    },
    {
      value: "DepotGateInwards",
      label: "Depot Gate Inwards",
    }
  ];

  const handleChange = (selectedOption) => {
    setSelectedComponent(selectedOption);
  };
  const navigate = useNavigate();
  const [fromdate, setFromdate] = useState(
    new Date(new Date().getFullYear(), 0, 2).toISOString()
  );
  const [todate, setTodate] = useState(new Date().toISOString());
  const [VehicleNo, setVehicleNo] = useState([]);
  var [selvehicleNo, setSelVehicleNo] = useState("");
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [data, setData] = useState([]);
  const [datawithVehicleNo, setDataWithVehicleNo] = useState([]);
  const [isloading, setisloading] = useState(true);
  const [isLoading2, setLoading2] = useState(true);
  const [driver, setDriver] = useState([]);
  var [seldrivecode, setselDriveCode] = useState("");
  var [seldrivername, setseldrivername] = useState("");
  const [datawithvehinoanddrivercode, setdatawithvehinoanddrivercode] =
    useState([]);
  const [datawithdrivercode, setDatawithdrivercode] = useState([]);

  useEffect(() => {
    setisloading(false);
  }, [selvehicleNo, fromdate, todate, seldrivecode, seldrivername]);

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div>
      <TransportDashboardsNavbar />
      <header className="header__of__main__dashboard flex justify-between items-end px-3">
        <h2 className="header__of__page">CONTAINTER DEPOT DASHBOARDS</h2>

        <div className="w-[400px] mx-2 " style={{ zIndex: 999 }}>
          <Select
            value={selectedComponent}
            onChange={handleChange}
            options={options}
            placeholder="Select Component"
          />
        </div>
      </header>

      <div>
        {selectedComponent &&
          selectedComponent.value === "DepotOutwardInterchange" && (
            <DepotOutwardInterchange />
          )}
        {selectedComponent &&
          selectedComponent.value === "DepotGateInwards" && (
            <DepotGateInwards />
          )}
      </div>
    </div>
  );
};

export default Depot;
